'use strict';

namespace TR {

    class BookingLookup {
        tooltip: string;

        constructor(
            private accountMenuService: any,
            private authService: any,
            private resourceService: Core.ResourceService
        )
        {
            this.tooltip = this.resourceService.get('MANAGEMYBOOKINGTOOLTIP');
        }


        public popupSignIn = (event) => {
            event.preventDefault();

            this.authService.bufferRoute(null);

            //redirect here is only used in the mobile version of accountMenuService
            this.accountMenuService.launchOption('bookingsignin');

        }
    }


    angular
        .module('TR')
        .directive('bookingLookup', () => {
            return {
                scope: {},
                controller: BookingLookup,
                controllerAs: 'as',
                restrict: 'E',
                replace: true,
                template: `
                    <span 
                        event-tracker
                        event-category="MYB"
                        event-action="click"
                        event-label="'MYB_HomePage'"
                        ng-click="as.popupSignIn($event)" 
                        title="{{as.tooltip}}" ng-transclude><span>`,
                transclude: true
            };
        });
}
